import ProviderDetailsLanguages from './ProviderDetailsLanguages'
export default ProviderDetailsLanguages
